import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography, Grid, IconButton, Divider, Paper, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ImageIcon from "@mui/icons-material/Image";
import DeleteIcon from "@mui/icons-material/Delete";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const AddSoOlympiad = ({ closePopup, modalData }) => {
    const [oldData, setOldData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [entryAttachments, setEntryAttachments] = useState({});
    const [entrySubmitting, setEntrySubmitting] = useState({});
    const [attachmentData, setAttachmentData] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [formData, setFormData] = useState({
        study_material_invoice_no: "",
        study_material_invoiced_amount: "",
        study_material_invoice_date: "",
    });
    const [openRemarkModal, setOpenRemarkModal] = useState(false);
    const [remark, setRemark] = useState("");

    // ================= GET OLD DATA =================
    useEffect(() => {
        if (modalData?.regId) {
            getOldData();
        }
    }, [modalData?.regId]);

    const getOldData = async () => {
        try {
            if (!modalData?.regId) return;
            setHistoryLoading(true);
            const result = await window.Platform.database.getSOBOforOlympiadByRegId({
                regId: modalData.regId,
            });
            if (result?.status) {
                setOldData(result?.data || []);
            } else {
                setOldData([]);
            }
        } catch (error) {
            console.log(error);
            setOldData([]);
        } finally {
            setHistoryLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        if (!formData.study_material_invoice_no?.toString().trim()) {
            window.NotificationUtils.showError("Please enter Study Material Invoice Number");
            return;
        }
        if (!formData.study_material_invoiced_amount?.toString().trim()) {
            window.NotificationUtils.showError("Please enter Study Material Amount");
            return;
        }
        if (!formData.study_material_invoice_date?.toString().trim()) {
            window.NotificationUtils.showError("Please select Study Material Invoice Date");
            return;
        }
        if (!attachmentData.length) {
            window.NotificationUtils.showError("Please upload at least one attachment");
            return;
        }
if (!remark?.trim()) {
    window.NotificationUtils.showError("Please enter remark");
    return;
}
if (remark?.trim()?.length <= 20) {
    window.NotificationUtils.showError("Remark Must be 20 Characters");
    return;
}
 
        try {
            setLoading(true);
            const formPayload = new FormData();
            attachmentData.forEach((fileObj) => {
                if (fileObj?.file instanceof File) {
                    formPayload.append("files", fileObj.file);
                }
            });
            formPayload.append("regId", modalData?.regId || "");
            formPayload.append("partyId", modalData?.partyId || "");
            formPayload.append("userId", modalData?.userId || "");
            formPayload.append("study_material_so_no", formData?.study_material_invoice_no || "");
            formPayload.append("study_material_so_amount", formData?.study_material_invoiced_amount || "");
            formPayload.append("study_material_so_date", formData?.study_material_invoice_date || "");
            formPayload.append("remark", remark);

            const result = await window.Platform.database.saveSOBOforOlympiad(formPayload);

            if (result?.status) {
                window.NotificationUtils.showSuccess(result?.message || "Added successfully");
                closePopup();
                getOldData();
                setFormData({
                    study_material_invoice_no: "",
                    study_material_invoiced_amount: "",
                    study_material_invoice_date: "",
                });
                setAttachmentData([]);
                setRemark("");
                setOpenRemarkModal(false);
            } else {
                window.NotificationUtils.showError(result?.message || "Something went wrong");
            }
        } catch (error) {
            console.log(error);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    // ================= NEW FORM FILE UPLOAD =================
    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        if (!files?.length) return;
        const mappedFiles = files.map((file) => ({
            file,
            name: file.name,
            type: file.type,
            preview: URL.createObjectURL(file),
        }));
        setAttachmentData((prev) => [...prev, ...mappedFiles]);
    };

    const handleRemoveAttachment = (indexToRemove) => {
        const isConfirm = window.confirm("Are you sure you want to remove this attachment?");
        if (!isConfirm) return;
        setAttachmentData((prev) => prev.filter((_, index) => index !== indexToRemove));
    };

    // ================= PER-ENTRY FILE UPLOAD =================
    const handleEntryFileUpload = (e, entryId) => {
        const files = Array.from(e.target.files);
        if (!files?.length) return;
        const mappedFiles = files.map((file) => ({
            file,
            name: file.name,
            type: file.type,
            preview: URL.createObjectURL(file),
        }));
        setEntryAttachments((prev) => ({
            ...prev,
            [entryId]: [...(prev[entryId] || []), ...mappedFiles],
        }));
    };

    const handleRemoveEntryAttachment = (entryId, indexToRemove) => {
        const isConfirm = window.confirm("Are you sure you want to remove this attachment?");
        if (!isConfirm) return;
        setEntryAttachments((prev) => ({
            ...prev,
            [entryId]: (prev[entryId] || []).filter((_, i) => i !== indexToRemove),
        }));
    };

    const handleEntrySubmit = async (item, entryId) => {
        const files = entryAttachments[entryId] || [];
        if (!files.length) {
            window.NotificationUtils.showError("Please upload at least one attachment");
            return;
        }

        try {
            setEntrySubmitting((prev) => ({ ...prev, [entryId]: true }));

            const formPayload = new FormData();
            files.forEach((fileObj) => {
                if (fileObj?.file instanceof File) {
                    formPayload.append("files", fileObj.file);
                }
            });
            formPayload.append("id", entryId || "");
            formPayload.append("regId", modalData?.regId || "");
            formPayload.append("partyId", modalData?.partyId || "");
            formPayload.append("userId", modalData?.userId || "");

            const result = await window.Platform.database.addAttachmentToSOBOEntry(formPayload);

            if (result?.status) {
                window.NotificationUtils.showSuccess(result?.message || "Attachments added successfully");
                // Clear uploaded files for this entry
                setEntryAttachments((prev) => ({ ...prev, [entryId]: [] }));
                // Refresh old data to show new images
                getOldData();
            } else {
                window.NotificationUtils.showError(result?.message || "Something went wrong");
            }
        } catch (error) {
            console.log(error);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setEntrySubmitting((prev) => ({ ...prev, [entryId]: false }));
        }
    };

    // ================= ATTACHMENT PREVIEW GRID (reusable) =================
// const AttachmentGrid = ({ files, onRemove, onPreview }) => (
//     <Box mt={2}>
//         <Grid container spacing={2}>
//             {files.map((att, index) => {
//                 // handles both local preview (new uploads) and server path (existing)
//                 const src = att?.preview || att?.path || null;
//                 const isImage =
//                     att?.type?.startsWith("image") ||        // new local file
//                     /\.(jpg|jpeg|png|gif|webp)/i.test(att?.path || ""); // server file

//                 return (
//                     <Grid item xs={12} sm={6} md={3} key={index}>
//                         <Paper
//                             elevation={2}
//                             sx={{ p: 1, borderRadius: 2, position: "relative", overflow: "hidden" }}
//                         >
//                             {onRemove && (
//                                 <Tooltip title="Remove">
//                                     <IconButton
//                                         size="small"
//                                         onClick={() => onRemove(index)}
//                                         sx={{ position: "absolute", top: 5, right: 5, zIndex: 2, background: "#fff" }}
//                                     >
//                                         <DeleteIcon fontSize="small" color="error" />
//                                     </IconButton>
//                                 </Tooltip>
//                             )}

//                             {/* Zoom button for server images */}
//                             {att?.path && (
//                                 <Tooltip title="Preview">
//                                     <IconButton
//                                         size="small"
//                                         onClick={() => setPreviewImage(att.path)}
//                                         sx={{ position: "absolute", top: 5, left: 5, zIndex: 2, background: "#fff" }}
//                                     >
//                                         <ZoomInIcon fontSize="small" color="primary" />
//                                     </IconButton>
//                                 </Tooltip>
//                             )}

//                             {isImage ? (
//                                 <img
//                                     src={src}
//                                     alt={att?.originalName || att?.name || "attachment"}
//                                     onClick={() => src && setPreviewImage(src)}
//                                     style={{
//                                         width: "100%",
//                                         height: "140px",
//                                         objectFit: "cover",
//                                         borderRadius: "8px",
//                                         cursor: "pointer",
//                                     }}
//                                 />
//                             ) : (
//                                 <Box
//                                     sx={{
//                                         height: "140px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         justifyContent: "center",
//                                         background: "#f5f5f5",
//                                         borderRadius: "8px",
//                                     }}
//                                 >
//                                     <ImageIcon sx={{ fontSize: 50, color: "#999" }} />
//                                 </Box>
//                             )}

//                             <Typography
//                                 variant="caption"
//                                 sx={{ mt: 1, display: "block", textAlign: "center", wordBreak: "break-word" }}
//                             >
//                                 {att?.originalName || att?.name || att?.fileName || "File"}
//                             </Typography>
//                         </Paper>
//                     </Grid>
//                 );
//             })}
//         </Grid>
//     </Box>
// );
const AttachmentGrid = ({ files, onRemove, onPreview, height = "140px" }) => (
    <Box mt={2}>
        <Grid container spacing={2}>
            {files.map((att, index) => {
                const src = att?.preview || att?.path || null;

                const isImage =
                    att?.type?.startsWith("image") ||
                    /\.(jpg|jpeg|png|gif|webp)/i.test(att?.path || "");

                const isPdf =
                    att?.type === "application/pdf" ||
                    /\.pdf$/i.test(att?.path || att?.name || "");

                return (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                        <Paper
                            elevation={2}
                            sx={{ p: 1, borderRadius: 2, position: "relative", overflow: "hidden" }}
                        >
                            {onRemove && (
                                <Tooltip title="Remove">
                                    <IconButton
                                        size="small"
                                        onClick={() => onRemove(index)}
                                        sx={{ position: "absolute", top: 5, right: 5, zIndex: 2, background: "#fff" }}
                                    >
                                        <DeleteIcon fontSize="small" color="error" />
                                    </IconButton>
                                </Tooltip>
                            )}

                            {att?.path && (
                                <Tooltip title="Preview">
                                    <IconButton
                                        size="small"
                                        onClick={() => setPreviewImage(att.path)}
                                        sx={{ position: "absolute", top: 5, left: 5, zIndex: 2, background: "#fff" }}
                                    >
                                        <ZoomInIcon fontSize="small" color="primary" />
                                    </IconButton>
                                </Tooltip>
                            )}

                            {isImage ? (
                                <img
                                    src={src}
                                    alt={att?.originalName || att?.name || "attachment"}
                                    onClick={() => src && setPreviewImage(src)}
                                    style={{
                                        width: "100%",
                                        height,
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                    }}
                                />
                            ) : isPdf ? (
                                // ── PDF: show iframe preview if it's a local blob, else icon+open link ──
                                src?.startsWith("blob:") ? (
                                    <Box
                                        sx={{
                                            height,
                                            borderRadius: "8px",
                                            overflow: "hidden",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => window.open(src, "_blank")}
                                    >
                                        <iframe
                                            src={src}
                                            title={att?.name || "PDF"}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                border: "none",
                                                pointerEvents: "none",  // click goes to Box, not iframe
                                            }}
                                        />
                                    </Box>
                                ) : (
                                    <Box
                                        onClick={() => att?.path && window.open(att.path, "_blank")}
                                        sx={{
                                            height,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: "#fff3f3",
                                            borderRadius: "8px",
                                            cursor: att?.path ? "pointer" : "default",
                                            border: "1px solid #ffcccc",
                                        }}
                                    >
                                        <PictureAsPdfIcon sx={{ fontSize: 50, color: "#e53935" }} />
                                        <Typography variant="caption" sx={{ color: "#e53935", mt: 0.5 }}>
                                            Open PDF
                                        </Typography>
                                    </Box>
                                )
                            ) : (
                                // ── Other files (doc, xls, etc.) ──
                                <Box
                                    sx={{
                                        height,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "#f5f5f5",
                                        borderRadius: "8px",
                                    }}
                                >
                                    <ImageIcon sx={{ fontSize: 50, color: "#999" }} />
                                    <Typography variant="caption" sx={{ color: "#999", mt: 0.5 }}>
                                        {att?.name?.split(".").pop()?.toUpperCase() || "File"}
                                    </Typography>
                                </Box>
                            )}

                            <Typography
                                variant="caption"
                                sx={{ mt: 1, display: "block", textAlign: "center", wordBreak: "break-word" }}
                            >
                                {att?.originalName || att?.name || att?.fileName || "File"}
                            </Typography>
                        </Paper>
                    </Grid>
                );
            })}
        </Grid>
    </Box>
);
    // ================= IMAGE FULLSCREEN PREVIEW =================
    const ImagePreviewOverlay = () => (
        previewImage ? (
            <Box
                onClick={() => setPreviewImage(null)}
                sx={{
                    position: "fixed",
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: "rgba(0,0,0,0.85)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "zoom-out",
                }}
            >
                <IconButton
                    onClick={() => setPreviewImage(null)}
                    sx={{ position: "absolute", top: 16, right: 16, color: "#fff" }}
                >
                    <CloseIcon />
                </IconButton>
                <img
                    src={previewImage}
                    alt="preview"
                    style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: 8, objectFit: "contain" }}
                />
            </Box>
        ) : null
    );

    return (
        <Box p={2} position="relative">
            <ImagePreviewOverlay />

            <Typography variant="h5" mb={2}>Add SO</Typography>

            <Typography>
                <span style={{ fontSize: "16px", color: "#000" }}>RNO ID: {modalData?.rno_id}</span> |
                <span style={{ fontSize: "16px", color: "#000", marginLeft: "10px" }}>RM Name: {modalData?.userName}</span> |
                <span style={{ fontSize: "16px", color: "#000", marginLeft: "10px" }}>
                    Party Name: {modalData?.schoolName} ({modalData?.partyId})
                </span>
            </Typography>

            <IconButton
                aria-label="close"
                onClick={closePopup}
                sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500], zIndex: 1 }}
            >
                <CloseIcon />
            </IconButton>

            <Divider sx={{ my: 2, width: "100%", opacity: 1, borderTop: "1px solid #000" }} />

            {/* ================= OLD ENTRIES ================= */}
            {historyLoading ? (
                <Typography mb={2}>Loading...</Typography>
            ) : (
                oldData?.map((item, index) => {
                    const entryId = item?.id;
                    const newFiles = entryAttachments[entryId] || [];
                    // Existing images saved in DB (adjust key based on your API response)
                    const existingImages = item?.study_materia_so_attachment || [];
                    const isSubmitting = entrySubmitting[entryId] || false;

                    return (
                        <Paper
                            key={entryId}
                            elevation={2}
                            sx={{ p: 2, mb: 3, background: "#f5f5f5" }}
                        >
                            <Typography variant="h6" mb={2} fontWeight={700}>
                                Previous Entry {index + 1}
                            </Typography>

                            {/* Entry Fields */}
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth disabled
                                        label="Study Material Invoice No"
                                        value={item?.study_material_so_no || ""}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth disabled
                                        label="Study Material Amount"
                                        value={item?.study_material_so_amount || ""}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth disabled
                                        type="date"
                                        label="Study Material Invoice Date"
                                        value={
                                            item?.study_material_so_date
                                                ? item.study_material_so_date.split("T")[0]
                                                : ""
                                        }
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                            </Grid>

                            {/* Existing Images */}
                            {existingImages.length > 0 && (
                                <Box mt={3}>
                                    <Typography variant="subtitle2" fontWeight={600} mb={1}>
                                        Uploaded Images
                                    </Typography>
                                    <AttachmentGrid
                                        files={existingImages}
                                        onRemove={null}
                                        onPreview={true}
                                    />
                                </Box>
                            )}


                            {/* Per-entry Upload Section */}
                            {/* <Typography variant="subtitle2" fontWeight={600} mb={1}>
                                Add Attachments to This Entry
                            </Typography>

                            <Button
                                variant="outlined"
                                component="label"
                                startIcon={<UploadFileIcon />}
                                size="small"
                            >
                                Upload Files
                                <input
                                    hidden
                                    multiple
                                    type="file"
                                    accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                    onChange={(e) => handleEntryFileUpload(e, entryId)}
                                />
                            </Button>

                            {newFiles.length > 0 && (
                                <AttachmentGrid
                                    files={newFiles}
                                    onRemove={(i) => handleRemoveEntryAttachment(entryId, i)}
                                    onPreview={true}
                                />
                            )}

                            <Box display="flex" justifyContent="flex-end" mt={2}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={() => handleEntrySubmit(item, entryId)}
                                    disabled={isSubmitting || newFiles.length === 0}
                                >
                                    {isSubmitting ? "Submitting..." : "Submit Attachments"}
                                </Button>
                            </Box> */}
                            <Box className="mt-3">
                                 <Typography variant="subtitle2" fontSize={16} fontWeight={600} mb={1}>
                                Discrepancy Remark: <span style={{color:"#ff0000"}}> {item?.despute_remark || "N/A"} </span>
                            </Typography>
                            </Box>
                        </Paper>
                    );
                })
            )}

            {/* ================= NEW FORM ================= */}
            <Typography variant="h6" mb={2} fontWeight={700}>
                Add New Entry
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="Study Material SO Number"
                        name="study_material_invoice_no"
                        value={formData.study_material_invoice_no}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        type="number"
                        label="Study Material Amount"
                        name="study_material_invoiced_amount"
                        value={formData.study_material_invoiced_amount}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        type="date"
                        label="Study Material Invoice Date"
                        name="study_material_invoice_date"
                        value={formData.study_material_invoice_date}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                {/* FILE UPLOAD */}
                <Grid item xs={12}>
                    <Button
                        variant="outlined"
                        component="label"
                        startIcon={<UploadFileIcon />}
                    >
                        Upload Attachment
                        <input
                            hidden
                            multiple
                            type="file"
                            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                            onChange={handleFileUpload}
                        />
                    </Button>

                    {attachmentData.length > 0 && (
                        <AttachmentGrid
                            files={attachmentData}
                            onRemove={handleRemoveAttachment}
                            onPreview={true}
                        />
                    )}
                </Grid>

                <Grid item xs={12}>
                    <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                        <Button variant="outlined" onClick={closePopup}>Cancel</Button>
                        {/* <Button variant="contained" onClick={handleSubmit} disabled={loading}>
                            {loading ? "Submitting..." : "Submit"}
                        </Button> */}
                        <Button variant="contained" onClick={() => setOpenRemarkModal(true)} disabled={loading}>
                            {loading ? "Submitting..." : "Submit"}
                        </Button>
                    </Box>
                </Grid>
            </Grid>

            <Dialog
                open={openRemarkModal}
                onClose={() => setOpenRemarkModal(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Add Remark</DialogTitle>

                <DialogContent>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        label="Enter Remark"
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        sx={{ mt: 1 }}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenRemarkModal(false)}>
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? "Submitting..." : "Submit"}
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>
    );
};

export default AddSoOlympiad;